import {forEach} from "lodash/collection.js";

export default function shuffleGrid() {
    const items = document.querySelectorAll('.tz-shuffle');
    const shuffles = [];
    if( items.length < 1 ) {
        return ;
    }
    forEach( items, (item) => {
        let s = new Shuffle(item, {
            itemSelector: '.item',
            sizer: null,
            gutterWidth: 24,
        });
        shuffles.push(s);
    } );
    return shuffles;
}